import React from 'react';
import Modal from '@mui/material/Modal';
import propTypes from 'prop-types';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import StripeContainer from '../../Components/Payments/StripeContainer';
import { StyledButton } from '../../Components/Generics.styled';

const NavigationSection = styled.div`
    margin-top: 20px;
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;

const LoginTextFieldContainer = styled.div`
    display: flex;
    width: 900px;
    flex-direction: column;
    justify-content: center;
    margin-top: 25px;
    margin-left: auto;
    margin-right: auto;
`;

const Title = styled.div`
    font-size: 30px;
    margin-bottom: 25px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    font-weight: bold;
    text-align: center;
`;
const Container = styled.div`
    margin-left: auto;
    margin-right: auto;
`;

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    width: 1100,
    padding: 23,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const AddPaymentMethodModal = (props) => {
    const { addPaymentModalIsOpen, setAddPaymentModalIsOpen, createPaymentMethod, postData } = props;

    const handleClose = () => {
        setAddPaymentModalIsOpen(false);
    };

    const body = (
        <div style={style}>
            <LoginTextFieldContainer>
                <Title>Add a Payment Method</Title>
                <Container>
                    <StripeContainer
                        buttonIsDisabled={false}
                        buttonStyle={{ marginTop: '20px' }}
                        onPayButtonSubmit={() => createPaymentMethod()}
                        buttonWidth="400px"
                        buttonLabel={
                            postData?.isLoading ? (
                                <CircularProgress
                                    style={{
                                        height: '20px',
                                        width: '20px',
                                        color: 'white',
                                    }}
                                    color="primary"
                                />
                            ) : (
                                'Add Payment Method'
                            )
                        }
                    />
                </Container>
            </LoginTextFieldContainer>

            <NavigationSection>
                <StyledButton onClick={() => handleClose()} variant="contained" color="primary">
                    Cancel
                </StyledButton>
            </NavigationSection>
        </div>
    );

    return (
        <div>
            <Modal
                open={addPaymentModalIsOpen}
                onClose={() => handleClose()}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
};

AddPaymentMethodModal.propTypes = {
    addPaymentModalIsOpen: propTypes.bool,
    setAddPaymentModalIsOpen: propTypes.func,
    createPaymentMethod: propTypes.func,
    postData: propTypes.shape({
        isLoading: propTypes.bool,
        success: propTypes.bool,
        error: propTypes.bool,
    }),
};

AddPaymentMethodModal.defaultProps = {
    addPaymentModalIsOpen: false,
    setAddPaymentModalIsOpen: () => {},
    createPaymentMethod: () => {},
    postData: {
        isLoading: false,
        success: false,
        error: false,
    },
};
export default AddPaymentMethodModal;
